import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const getMiddlewareList = (middlewareList) => {
  if (process.env.NODE_ENV === 'production') {
    return applyMiddleware(thunk, ...middlewareList);
  }

  const _compose = (process.browser && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  return _compose(
    applyMiddleware(thunk, createLogger(), ...middlewareList),
  );
};

const configureStore = (state = {}, middlewareList = []) => createStore(
  rootReducer, state, getMiddlewareList(middlewareList),
);

export default configureStore;
